module.exports = __webpack_public_path__ + "static/media/ic_medical_checkup2.008da705.svg";